import React from "react";
import { Link } from "react-router-dom";

const breadcrumbStyle = {
  fontSize: "13px",
};

const linkStyle = {
  color: "#000",
};

const CustomBreadcrumb = ({ current }) => {
  return (
    <div style={breadcrumbStyle}>
      <Link to="/" style={linkStyle}>
        Dashboard
      </Link>
      <span style={{ color: "#6c757d" }}>
        {current?.map((item, index) => {
          return (
            <span key={index}>
              &nbsp;/&nbsp;
              {item.route !== null ? (
                <Link to={item.route} style={{ color: "#000" }}>
                  {item.label}
                </Link>
              ) : (
                item.label
              )}
            </span>
          );
        })}
      </span>
    </div>
  );
};

export default CustomBreadcrumb;
